// نوع مصدر الدين
export enum DebtSourceType {
  MAINTENANCE = 'maintenance', // دين ناتج عن صيانة
  SALE = 'sale', // دين ناتج عن عملية بيع
  OTHER = 'other' // دين آخر
}

// حالة الدين
export enum DebtStatus {
  ACTIVE = 'active', // دين نشط (غير مسدد)
  PARTIALLY_PAID = 'partially_paid', // مسدد جزئياً
  PAID = 'paid', // مسدد بالكامل
  CANCELLED = 'cancelled' // ملغي
}

// نموذج الدين
export interface Debt {
  id: string;
  customerId: string; // معرف العميل
  customerName: string; // اسم العميل
  customerPhone: string; // رقم هاتف العميل
  amount: number; // المبلغ الإجمالي للدين
  remainingAmount: number; // المبلغ المتبقي
  paidAmount: number; // المبلغ المدفوع
  sourceType: DebtSourceType; // نوع مصدر الدين
  sourceId: string; // معرف المصدر (معرف طلب الصيانة أو معرف عملية البيع)
  sourceReference: string; // رقم مرجعي للمصدر (رقم طلب الصيانة أو رقم الفاتورة)
  description: string; // وصف الدين
  dueDate?: Date | string; // تاريخ استحقاق الدين
  status: DebtStatus; // حالة الدين
  createdAt: Date | string; // تاريخ إنشاء الدين
  updatedAt: Date | string; // تاريخ آخر تحديث للدين
  createdBy: string; // معرف المستخدم الذي أنشأ الدين
  createdByName: string; // اسم المستخدم الذي أنشأ الدين
  branchId: string; // معرف الفرع
  branchName: string; // اسم الفرع
  notes?: string; // ملاحظات إضافية
}

// نموذج دفعة سداد الدين
export interface DebtPayment {
  id: string;
  debtId: string; // معرف الدين
  amount: number; // مبلغ الدفعة
  paymentDate: Date | string; // تاريخ الدفعة
  paymentMethod: string; // طريقة الدفع
  receivedBy: string; // معرف المستخدم الذي استلم الدفعة
  receivedByName: string; // اسم المستخدم الذي استلم الدفعة
  notes?: string; // ملاحظات
  createdAt: Date | string; // تاريخ إنشاء السجل
}

// نموذج ملخص ديون العميل
export interface CustomerDebtSummary {
  customerId: string;
  customerName: string;
  totalDebt: number; // إجمالي الديون
  activeDebt: number; // الديون النشطة
  paidDebt: number; // الديون المسددة
  lastPaymentDate?: Date | string; // تاريخ آخر دفعة
  debtsCount: number; // عدد الديون
}
